export default "__VITE_ASSET__CtkwVwxH__"